// Brand-system icons for the visit report page (#28). The SVGs are bi-ton
// (green #d5ff4f + marine #314959) with their colours baked in via an inline
// <style>. They are served as static assets and rendered with <img>, NOT
// through the svgr `generate:icons` pipeline — that pipeline recolours paths
// (flattens the marine to #000 / overrides fill), which would destroy the
// bi-ton look. <img>-loaded SVGs keep their own styles, isolated from page CSS.
export const BRAND_ICON_BASE = '/static/img/brand';

export const iconUrl = (name) => `${BRAND_ICON_BASE}/${name}.svg`;

// Normalise an element_type for keyword matching: uppercase + strip accents,
// so both the API's SNAKE_CASE enum keys (CHAIN_CONDITION) and free-text
// French labels (Chaîne, Plaquettes avant) resolve to the right icon.
const normalize = (value) =>
  String(value || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');

// Map a diagnostic element_type to a brand icon name (spec §7). Keyword-based
// and order-sensitive (most specific first); falls back to PROBLEME_GENERIQUE.
// No COMPOSANT_CHAINE asset exists in the set → chain uses COMPOSANT_DERAILLEUR
// (spec §11.3).
//
// Ticket #380 added 5 element types (api PR #847). Four of them matched no
// keyword and would have rendered the generic icon, so the drivetrain rule
// picked up CASSETTE / CRANKSET (Transmission), the steering rule picked up
// FORK and the accessory rule picked up MUDGUARD / RACK (Sécurité & divers);
// HEADSET_CONDITION was already covered. `PEDALIER` deliberately stays on the
// OUTILS rule (it is BOTTOM_BRACKET's French label, "Boîtier de pédalier"),
// while CRANKSET's own label "Pédalier / plateaux" is caught upstream by
// PLATEAU — so the two pedal-side types keep their distinct icons.
export const iconForElementType = (elementType) => {
  const key = normalize(elementType);
  if (!key) return 'PROBLEME_GENERIQUE';
  if (
    /(CHAIN|CHAINE|TRANSMISSION|DERAILLEUR|CASSETTE|ROUE.?LIBRE|FREEWHEEL|CRANKSET|PLATEAU)/.test(
      key,
    )
  ) {
    return 'COMPOSANT_DERAILLEUR';
  }
  if (/(BRAKE|BREAKING|LEVER|FREIN|PLAQUETTE)/.test(key)) {
    return 'COMPOSANT_FREIN';
  }
  if (/(TYRE|TIRE|PNEU)/.test(key)) return 'COMPOSANT_PNEU';
  if (/(WHEEL|ROUE)/.test(key)) return 'COMPOSANT_ROUE';
  if (/(SADDLE|SEAT|SELLE)/.test(key)) return 'COMPOSANT_SELLE';
  if (/(BELL|SONNETTE)/.test(key)) return 'COMPOSANT_SONNETTE';
  if (/(HANDLEBAR|GUIDON|HEADSET|DIRECTION|FORK|FOURCHE)/.test(key)) {
    return 'COMPOSANT_GUIDON';
  }
  if (/(LIGHT|ECLAIRAGE)/.test(key)) return 'ENERGIE';
  if (
    /(BOTTOM_BRACKET|PEDALIER|CABLE|GAINE|FRAME|CADRE|MUDGUARD|GARDE.?BOUE|RACK|PORTE.?BAGAGE)/.test(
      key,
    )
  ) {
    return 'OUTILS';
  }
  if (/NOTE/.test(key)) return 'CARNET_ENTRETIEN';
  return 'PROBLEME_GENERIQUE';
};

export default iconUrl;
